// Auto-generated build information - do not edit manually
// Generated at: 2026-10-14T15:03:29.980Z

export const buildInfo = {
  "buildNumber": "220-dev1791990209980",
  "buildDate": "2026-10-14T15:03:29.980Z",
  "gitCommit": "a194f21",
  "gitBranch": "dev",
  "gitTag": null,
  "environment": "dev"
} as const;

export type BuildInfo = typeof buildInfo;
